import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { LibraryContext } from '../../Contexts/LibraryContext/LibraryContext';
import { Col, Container, FloatingLabel, Form, Row } from 'react-bootstrap';
import { factionNames } from '../../hooks/useFactionData/useFactionData.constant';
import { SimplifiedSelectionEntry } from '../../types/Library/LibrarySimplified';

interface SelectUnitProps {
  faction?: string;
  onUnitSelected: (unit: SimplifiedSelectionEntry, factionName: string) => void;
}

function getDefaultUnitName(library: Map<string, SimplifiedSelectionEntry[] | undefined>, factionName: string) {
  const entries = library.get(factionName);

  return entries && entries[0] ? entries[0].name : undefined;
}

function getUnitNames(library: Map<string, SimplifiedSelectionEntry[] | undefined>, factionName: string): string[] {
  const entries = library.get(factionName);

  if(entries) {
    return entries.map((unit) => unit.name);
  }

  return [];
}

function SelectUnit({ faction, onUnitSelected }: SelectUnitProps) {
  const library = useContext(LibraryContext);

  const [factionName, setFactionName] = useState<string>(faction ?? factionNames[0]);
  const [unitName, setUnitName] = useState<string | undefined>(getDefaultUnitName(library, faction ?? factionNames[0]));

  useEffect(() => {
    if(faction) {
      setFactionName(faction);
    }
  }, [faction]);

  const factionMenuItems = useMemo(() => factionNames.map((t, i) => (
    <option key={`faction${i}`} value={t}>{t}</option>
  )), []);

  const unitMenuItems = useMemo(() => getUnitNames(library, factionName).map((t, i) => (
    <option key={`unitOptions${i}`} value={t}>{t}</option>
  )), [library, factionName]);
  
  const onSelection = useCallback((newUnitName: string) => {
    setUnitName(newUnitName);

    const entries = library.get(factionName);
    entries?.forEach((entry) => {
      if(entry.name === newUnitName) {
        onUnitSelected(entry, factionName);
      }
    });
  }, [onUnitSelected, factionName]);

  useEffect(() => {
    onSelection(getDefaultUnitName(library, factionName) ?? '');
  }, [library, factionName]);

  return (
    <div>
      <Container style={{ padding: '0px' }}>
        <Row>
          <Col>
            <FloatingLabel label="Faction" className="mb-3">
              <Form.Select value={factionName} onChange={(event) => setFactionName(event.target.value)}>
                {factionMenuItems}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col>
            <FloatingLabel label="Unit" className="mb-3">
              <Form.Select value={unitName} onChange={(event) => onSelection(event.target.value)}>
                {unitMenuItems}
              </Form.Select>
            </FloatingLabel>
          </Col>
          
          
        </Row>
      </Container>
    </div>
  );
}

export default SelectUnit;